import { useParams, Link } from "react-router-dom";
import { useGetBlogPostBySlugQuery } from "../features/api/blogApiSlice";
import "../styles/blogDetail.scss";
import FuelLoading from "./FuelLoading";
import SEO from "../components/seo/SEO";
import { useToast } from "../components/toast/ToastContext";

export default function BlogPostDetail() {
  const { slug } = useParams();
  const { data: post, isLoading, isError } = useGetBlogPostBySlugQuery(slug);
  const { showToast } = useToast();

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  // NEW Function: Copies the exact current browser link and fires a global toast notice
  const handleShareLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      // 🟢 REPLACED LOCAL STATE BUTTON TEXT TOGGLE WITH GLOBAL TOAST NOTIFIER
      showToast(
        "Journey URL tracking link copied to your clipboard!",
        "success"
      );
    } catch (err) {
      showToast(
        "Failed to write coordinates destination link to clipboard.",
        "error"
      );
    }
  };

  // const shareText = encodeURIComponent(
  //   `Check out this journey segment from Mini Miles Adventures: "${post.title}" 🚗💨`
  // );
  const shareUrl = encodeURIComponent(window.location.href);

  const triggerTwitterShare = () => {
    window.open(
      `https://twitter.com{shareText}&url=${shareUrl}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const triggerFacebookShare = () => {
    window.open(
      `https://facebook.com{shareUrl}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  if (isLoading) {
    return (
      <div className="blog-detail-loading">
        <FuelLoading text="Refueling page memory tracks..." />
      </div>
    );
  }

  if (isError || !post) {
    return (
      <div className="blog-detail-error">
        <h2>⚠️ Route Destination Lost</h2>
        <p>
          This journal log page entry doesn't exist or was turned back down the
          road.
        </p>
        <Link to="/blog" className="back-home-link">
          ← Return to Journal Feed
        </Link>
      </div>
    );
  }

  return (
    <main className="blog-post-page fuel-fade-in">
      {/* 🟢 DYNAMIC SEO INJECTOR: Re-evaluates headers instantly for search bots */}
      <SEO
        title={post.title}
        description={post.excerpt}
        slug={`/blog/${post.slug}`}
        image={post.coverImage}
        type="article"
      />

      <article className="blog-article-content">
        {/* Upper Meta Info Rows */}
        <header className="blog-article-header">
          <Link to="/blog" className="back-feed-btn">
            ← Back to Journal
          </Link>
          <div className="blog-article-meta">
            <span className="category-tag">{post.category}</span>
            <time>{formatDate(post.createdAt)}</time>
            <span className="detail-read-time">
              ⏱️ {post.readingTime || 1} minute read
            </span>
          </div>
          <h1>{post.title}</h1>
          <p className="article-excerpt-lead">“ {post.excerpt} ”</p>
        </header>

        {/* Hero Banner Cover Block */}
        <div className="blog-article-banner">
          <img src={post.coverImage} alt={post.title} />
        </div>

        {/* Core Narrative Body Container Text Panel */}
        <div
          className="blog-article-body text-rich"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        {/* FOOTER AREA PANEL */}
        <div className="article-footer-actions">
          {/* Left Section Primary Actions Row Control */}
          <div className="primary-actions-row">
            <button
              type="button"
              className="article-share-btn"
              onClick={handleShareLink}
            >
              🔗 Copy Track Link
            </button>
            <Link to="/blog" className="fuel-secondary-btn return-btn">
              🗺️ Browse More Stories
            </Link>
          </div>

          {/* 🟢 NEW: QUICK-CLICK SOCIAL SHARE CHANNELS */}
          <div className="social-quick-shares">
            <span>Broadcast Drive:</span>
            <button
              type="button"
              className="share-node share-node--twitter"
              onClick={triggerTwitterShare}
            >
              🐦 Share on X
            </button>
            <button
              type="button"
              className="share-node share-node--facebook"
              onClick={triggerFacebookShare}
            >
              👥 Share on FB
            </button>
          </div>
        </div>
      </article>
    </main>
  );
}
